import { useQueryClient } from '@tanstack/react-query';
import { useGoodsSno } from './useGoodsSno';
import { useCallback, useEffect } from 'react';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api';

export const usePreloadQuery = () => {
  const client = useQueryClient();
  const goodsSno = useGoodsSno();

  const preloadQuery = useCallback(() => {
    client.prefetchQuery({
      queryKey: queryKey.relatedGoods(goodsSno),
      queryFn: () => goodsService.getRelatedGoods(goodsSno),
    });
    client.prefetchQuery({
      queryKey: queryKey.goodsOptionsBrief(goodsSno),
      queryFn: () => goodsService.getGoodsOptionsBrief(goodsSno),
    });
    client.prefetchQuery({
      queryKey: queryKey.goodsOptions(goodsSno, { depth: 1 }),
      queryFn: () => {
        return goodsService.getGoodsOptions(goodsSno, { depth: 1 });
      },
    });
  }, [client, goodsSno]);

  useEffect(() => {
    preloadQuery();
  }, [preloadQuery]);
};
